module.exports = __webpack_public_path__ + "img/visa.1abc4f57.png";